import React, { Component } from "react";

import './App.css';
import { render } from "@testing-library/react";

import Delayed from './Delayed';

import About from "./components/About";
import Main from "./components/Main";
import Projects from "./components/Projects";
import Contact from "./components/Contact"

import Pdf from './Documents/Vinayak Goswami.pdf'


class App extends Component {
  constructor() {
    super();
    this.state = {
      name: "Vinayak Goswami",
      showComponentCount: 0
    };
    this.showComponent = this.showComponent.bind(this)
  }

  showComponent (count) {
    this.setState({ showComponentCount: count })
  }

  render(){
    const { showComponentCount } = this.state
    return(
      <div className="App">
        
        <div className="content">

          <div className="post">
          
            <div className="nav center">
              <span className="options" onClick={() => this.showComponent(0)}>
                /Main
              </span>
              <span className="options" onClick={() => this.showComponent(1)}>
                /About
              </span>
              <span className="options" onClick={() => this.showComponent(2)}>
                /Projects
              </span>
              <span className="options" onClick={() => this.showComponent(3)}>
                /Contact_Me
              </span>
              <span className="options" onClick={() => window.open(Pdf)}>
                /Resume
              </span>
            </div>

            <br />


            {showComponentCount === 0 ? <Main /> : null}
            {showComponentCount === 1 ? <About /> : null}
            {showComponentCount === 2 ? <Projects /> : null}
            {showComponentCount === 3 ? <Contact /> : null}
        
          </div>
        
        </div>
      
      </div>
    );
  }
}

export default App;
